import { CloseButton } from "@mantine/core";
import { type CloseButtonProps } from "@mantine/core";
import React from "react";

type StyledCloseButtonProps = CloseButtonProps & React.ComponentPropsWithoutRef<"button">;

export const StyledCloseButton = React.forwardRef<HTMLButtonElement, StyledCloseButtonProps>((props, ref) => {
  const { style, ...rest } = props;
  return (
    <CloseButton
      ref={ref}
      style={{
        color: "white",
        borderRadius: "50%",
        ...style,
      }}
      styles={{
        root: {
          "&:hover": {
            color: "white",
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          },
          "& > svg": {
            width: "1.5rem",
            height: "1.5rem",
          },
        },
      }}
      {...rest}
    />
  );
});
